import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const BannersWrapper = styled.div`
	margin: ${token('space.050')};
	display: flex;
	flex-direction: column;
	row-gap: ${token('space.150')};
`;

export const Banner = styled.div`
	background-color: ${token('elevation.surface.sunken')};
	padding: ${token('space.300')};
    box-shadow: 0 1px 1px rgba(9,30,66,0.25), 0 0 1px 1px rgba(9,30,66,0.13)
`;
